import { FastSelectionButtonsWidget, IStationData, IUndergroundMapWidgetContext } from '@cian/underground-map-widget';
import * as React from 'react';
import { ILocation } from '../../../api/locations';
import { CloseBtn } from '../../../common/components/close_button';
import { Modal } from '../../../common/components/modal';
import { ModalWrapper } from '../../../common/components/modal/wrapper';
import { EMetroTravelType } from '../../../json_query';
import { MetroModalHeader } from './header';
import { UndergroundMapSchemeWidget } from './temp_helpers';
import { trackMetroModalOpenEvent } from './tracking';
const style = require('./index.css');
const headerStyle = require('./header/index.css');

export interface IMetroModalProps {
  undergroundMapSchemeWidgetService: IUndergroundMapWidgetContext | undefined;

  selectedIds: number[] | undefined;
  location: ILocation | 'moscow_mo' | 'spb_lo';
  travelType: EMetroTravelType;
  travelTime: number;
  searchButton: React.ReactNode;
  stationsUnderConstruction: number[] | undefined;

  onClose(): void;
  onUndergroundTravelChanged(travelType: EMetroTravelType, travelTime: number | undefined): void;
  onRemove(stations: IStationData[]): void;
  onSelect(stations: IStationData[]): void;
}

export class MetroModal extends React.Component<IMetroModalProps> {
  public componentDidMount() {
    trackMetroModalOpenEvent();
  }

  public render() {
    const { undergroundMapSchemeWidgetService, stationsUnderConstruction } = this.props;

    if (!undergroundMapSchemeWidgetService) {
      return null;
    }

    const locationId = this.getLocationId();

    return (
      <ModalWrapper onClose={this.props.onClose}>
        <Modal
          minHeigth={200}
          minWidth={1000}
          width="85%"
          closeBtn={<CloseBtn onClick={this.props.onClose} isTransparent />}
          header={
            <MetroModalHeader
              fastSelectionButtons={
                <FastSelectionButtonsWidget
                  widgetContext={undergroundMapSchemeWidgetService}
                  locationId={locationId}
                  selectedIds={this.props.selectedIds || []}
                  onRemove={this.props.onRemove}
                  onSelect={this.props.onSelect}
                  containerStyle={headerStyle['buttonsWrapper']}
                />
              }
              travelType={this.props.travelType}
              travelTime={this.props.travelTime}
              onUndergroundTravelChanged={this.props.onUndergroundTravelChanged}
            />
          }
          footer={<div className={style['footer']}>{this.props.searchButton}</div>}
        >
          <UndergroundMapSchemeWidget
            widgetContext={undergroundMapSchemeWidgetService}
            selectedIds={this.props.selectedIds || []}
            locationId={locationId}
            onRemove={this.props.onRemove}
            onSelect={this.props.onSelect}
            containerStyle={style['metroWrapper']}
            stationsUnderConstruction={stationsUnderConstruction}
          />
        </Modal>
      </ModalWrapper>
    );
  }

  private getLocationId = (): number => {
    let locationId;

    if (this.props.location === 'moscow_mo') {
      locationId = 1;
    } else if (this.props.location === 'spb_lo') {
      locationId = 2;
    } else {
      locationId = this.props.location.id;
    }

    return locationId;
  };
}
